function Social() {
    const socialLinks = [
      {
        platform: 'Instagram',
        username: '@ngenart_co',
        url: 'https://instagram.com/ngenart_co',
        description: 'Follow us for updates, feature previews, and beautiful data visualizations.',
      },
      {
        platform: 'Twitter',
        username: '@ngenart_co',
        url: 'https://x.com/ngenart_co',
        description: 'Follow for in-progress updates, feature previews, and more!',
      },
    ];
  
    return (
      <div style={styles.container}>
        <h1 style={styles.title}>Connect With Us</h1>
        
        <div style={styles.socialGrid}>
          {socialLinks.map((social) => (
            <a 
              key={social.platform}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.socialCard}
            >
              <h2 style={styles.platformTitle}>{social.platform}</h2>
              <p style={styles.username}>{social.username}</p>
              <p style={styles.description}>{social.description}</p>
            </a>
          ))}
        </div>
      </div>
    );
  }
  
  const styles = {
    container: {
      padding: '2rem',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: '"Bodoni Moda", serif',
      backgroundColor: '#fffef7',
    },
    title: {
      fontSize: '2.5rem',
      marginBottom: '3rem',
      color: '#0a0a0a',
      textAlign: 'center',
    },
    socialGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '2rem',
      padding: '1rem',
    },
    socialCard: {
      padding: '2rem',
      border: '1px solid rgba(0,0,0,0.1)',
      borderRadius: '12px',
      textDecoration: 'none',
      transition: 'all 0.2s ease',
      backgroundColor: '#fffef7',
      ':hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      },
    },
    platformTitle: {
      fontSize: '1.8rem',
      marginBottom: '0.5rem',
      color: '#0a0a0a',
    },
    username: {
      fontSize: '1.2rem',
      color: '#666',
      marginBottom: '1rem',
    },
    description: {
      fontSize: '1.1rem',
      lineHeight: '1.6',
      color: '#0a0a0a',
    },
  };
  
  export default Social;